import React from 'react';
import './CategorySelection.css';

function CategorySelection({ categories, onSelectCategory, isPremium }) {
  const categoryPresentation = {
    friend: {
      title: 'دوستانه',
      description: 'مخصوص دورهمی‌های صمیمی و رفقای قدیمی',
      icon: 'group'
    },
    newFriend: {
      title: 'دوست جدید',
      description: 'برای شروع آشنایی‌های تازه و پیدا کردن وجه اشتراک‌ها',
      icon: 'handshake'
    },
    family: {
      title: 'خانوادگی',
      description: 'چقدر از خاطرات و علایق اعضای خانواده خبر داری؟',
      icon: 'family_restroom'
    },
    colleague: {
      title: 'همکاران',
      description: 'شناخت بهتر افرادی که هر روز کنارشان هستی',
      icon: 'work'
    },
    spouse: {
      title: 'عاشقانه',
      description: 'سوالاتی برای کشف لایه‌های پنهان قلب‌ها',
      icon: 'favorite'
    },
    crush: {
      title: 'کراش',
      description: 'برای شناخت بیشتر و یک شروع صمیمی‌تر',
      icon: 'favorite'
    },
    classmate: {
      title: 'هم‌کلاسی',
      description: 'برای مرور خاطره‌ها و علایق مشترک کلاس',
      icon: 'school'
    },
    follower: {
      title: 'دنبال‌کننده‌ها',
      description: 'ببین مخاطب‌هایی که همراهت هستند چقدر تو را می‌شناسند',
      icon: 'groups'
    }
  };

  return (
    <div className="step-section stitch-create-step">
      <div className="step-header stitch-create-heading stitch-category-heading">
        <h1>شروع بازی جدید</h1>
        <p>یک دسته‌بندی انتخاب کن تا عمق رابطه‌ات رو بسنجی!</p>
      </div>

      <div className="categories-grid stitch-category-grid">
        {categories.map((category) => {
          const presentation = categoryPresentation[category.id] || {
            title: category.name,
            description: category.description,
            icon: 'quiz'
          };

          return (
          <button
            key={category.id}
            className={`category-card category-${category.id} ${category.isPremium ? 'premium' : ''}`}
            onClick={() => onSelectCategory(category.id)}
            type="button"
          >
            <span className="category-icon-wrap">
              <span className="category-emoji material-symbols-outlined">{presentation.icon}</span>
              {category.isPremium && !isPremium && (
                <span className="premium-badge" aria-label="ویژگی حرفه‌ای">
                  <span className="material-symbols-outlined">star</span>
                  حرفه‌ای
                </span>
              )}
            </span>
            <span className="category-copy">
              <span>
                <strong>{presentation.title}</strong>
                <small>{presentation.description}</small>
              </span>
              <span className="category-arrow material-symbols-outlined" aria-hidden="true">chevron_left</span>
            </span>
          </button>
          );
        })}
      </div>
      <p className="stitch-category-hint">دسته‌های حرفه‌ای با ستاره مشخص شده‌اند و با فعال‌سازی نسخه حرفه‌ای در دسترس‌اند.</p>
    </div>
  );
}

export default CategorySelection;
